// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-tip[data-v-247e7dd8] {\n  font-size: 0.34667rem;\n  font-weight: 500;\n  color: #838383;\n  line-height: 0.34667rem;\n}\n", ""]);
// Exports
module.exports = exports;
